module.exports = __webpack_public_path__ + "static/media/dice-one.3c7123f9.svg";